import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, [
    _createElementVNode("g", { "stroke-width": "0" }),
    _createElementVNode("g", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    _createElementVNode("g", null, [
      _createElementVNode("path", { d: "M3.893 15.947l-.927.547L12 21.838l9.033-5.342-.927-.547.983-.582L23 16.495 12 23 1 16.493l1.91-1.128zM23 8.495L12 15 1 8.493 12 2zm-10.999 5.343l9.033-5.342-9.033-5.335-9.035 5.333zm9.089-2.47l-.983.58.927.548-9.033 5.342-9.035-5.344.927-.547-.983-.582L1 12.493 12 19l11-6.505z" }),
      _createElementVNode("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
      })
    ])
  ]))
}